<aside class="w-full flex flex-col gap-6" *ngIf="dataSource; else noData" id="asideDesk" #asideDesk>
  <iho-plp-map *ngIf="!searchUiService.isCountryPage()" [mapUrl]="mapUrlMain" [accommodation]="accommodation()" />
  <div id="filters-sidebar" class="shadow-sm !bg-white" #filtersSidebar>
    <div
      class="w-full flex flex-col justify-between items-center px-2 py-5 max-h-24 sticky top-0 right-0 !z-10 !bg-white">
      <div class="w-full flex justify-between items-center h-16">
        <div>
          <h6 class="text-base font-bold">فیلتر ها</h6>
        </div>

        <div class="!pointer-events-auto" (click)="removeAllFilters($event)" *ngIf="Filters.length">
          <button class="!border antialiased
            !border-solid
            !border-blue-500" mat-button color="primary">
            حذف فیلترها
          </button>
        </div>
      </div>

      <div class="w-full h-[1px] bg-gray-100 rounded-md mt-3"></div>

    </div>
    <mat-accordion [multi]="true" class="filters-sidebar-accordion !text-black w-full flex flex-col !pt-0 !mt-0">
      <mat-expansion-panel 
      *ngFor="let item of dataSource; let first = first; let last = last; let i = index"
        [expanded]="expanded()" class="border-bottom"
        [class]="(first && accommodation() == 'ecolodge') ? 'order-1' : (last && accommodation() != 'ecolodge') ? 'order-1' : 'order-10'"
        [class.border-bottom-0.!pb-0]="(accommodation() != 'ecolodge' && i === dataSource?.length - 2) || (accommodation() == 'ecolodge' && i === dataSource?.length - 1)">  
        <mat-expansion-panel-header class="!px-0">
          <mat-panel-title>
            <div class="w-full flex justify-between items-center">
              <div>
                <p class="text-base font-bold">{{ item.Title }}</p>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div [ngSwitch]="item.Key">
          <div *ngSwitchCase="'labelsAccomodate'" >
            <ng-container *ngIf="showFilterComponents()">
              <iho-labels-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>

          </div>
          <div *ngSwitchCase="'labels'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-labels-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>
          </div>

          <div *ngSwitchCase="'reviews'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-comments-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>
          </div>

          <div *ngSwitchCase="'grades'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-stars-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>
          </div>

          <div *ngSwitchCase="'types'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-residence-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>
          </div>
          <div *ngSwitchCase="'hotelTypes'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-residence-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>
          </div>

          <div *ngSwitchCase="'price'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-price-filter (checkedMinValue)="MinValue($event)" (checkedMaxValue)="MaxValue($event)"
                [_maxValue]="maxPriceFilterInit!" [_minValue]="minPriceFilterInit!" [dataSource]="item.Items" />
            </ng-container>
          </div>
          <div *ngSwitchCase="'hotelStyles'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-type-of-location-filter (checkedItemsEmit)="checkedItemsEmit($event)" [dataSource]="item.Items" />
            </ng-container>
          </div>
          <div *ngSwitchCase="'facilities'">
            <ng-container *ngIf="showFilterComponents()">
              <iho-accommodation-facilities-filter (checkedItemsEmit)="checkedItemsEmit($event)"
                [dataSource]="item.Items" />
            </ng-container>
          </div>


        </div>

      </mat-expansion-panel>

    </mat-accordion>

  </div>
</aside>
<ng-template #noData>
  <iho-skeleton width="100%" height="176px" class="my-5 float-start !w-full" />
  <iho-skeleton width="100%" height="90vh" class="float-start !w-full" />
</ng-template>